/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-07-29 08:49:24
 **/

import { useEffect, useRef } from "react";
import { Subscription, interval } from "rxjs";

export default function useInterval() {
	const timerID = useRef<Subscription | null>(null);

	const start = (timeout: number, callback: () => void) => {
		timerID.current = interval(timeout).subscribe(() => {
			callback();
		});
	};

	const stop = () => {
		timerID.current?.unsubscribe();
		timerID.current = null;
	};

	useEffect(() => {
		return () => {
			stop();
		};
	}, []);

	return {
		start,
		stop,
		get is_started() {
			return timerID.current !== null;
		}
	};
}
